import HttpClientToken from '../../services/HttpClientToken';

import { defaultPais, PaisProps } from '../../interfaces/catalogos/PaisInterface';

export const Pais = () => {

    return new Promise<PaisProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Pais/', token)
            .then( ({ data } : { data : PaisProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerPais = () => {

    return new Promise<PaisProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Pais/ObtenerPais', token)
            .then( ({ data } : { data : PaisProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarPais = ( params: PaisProps ) => {

    return new Promise<PaisProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Pais/Actualizar', params, token)
            .then( ({ data } : { data : PaisProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPais } );
            });

        }

    });

}

export const AgregarPais = ( params: PaisProps ) => {

    return new Promise<PaisProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Pais/Agregar', params, token)
            .then( ({ data } : { data : PaisProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPais } );
            });

        }

    });

}
